import { TableDetails } from 'olo-service/models';
import { useQuery } from 'react-query';
import { isSlug } from './isSlug';
import { useColoAxiosInstance } from './useColoRequest';

export const TABLE_KEYS = {
  table: (merchantId?: string, tableId?: string) => ['table', merchantId, tableId] as const,
} as const;

export function useTableDetailsResource(merchantId?: string, tableUuid?: string[] | string | null) {
  const tableId = Array.isArray(tableUuid) ? tableUuid[0] : tableUuid || '';
  const axios = useColoAxiosInstance();

  return useQuery(
    TABLE_KEYS.table(merchantId, tableId),
    async () => {
      const response = await axios.get<TableDetails>(`${merchantId}/tables/${tableId}`, {
        params: { slug: isSlug(merchantId) },
      });

      return response.data;
    },
    {
      enabled: !!merchantId && !!tableId,
      staleTime:Infinity
    }
  );
}
